import React from 'react';
import './pwa.css';

export default function AppBootScreen({ message = 'Opening Member Nest...' }) {
  return (
    <main className="app-boot-screen" role="status" aria-live="polite" aria-label={message}>
      <div className="app-boot-screen__logo-stage" aria-hidden="true">
        <img className="app-boot-screen__logo-image" src="/assets/logo.png" alt="" />
        <span className="app-boot-screen__logo-sheen" />
      </div>
      <p>{message}</p>
    </main>
  );
}
